@use "../../styles/breakpoint.module.scss" as *;

.container {
    composes: gridContainer from "../../styles/composable/layout.module.css";
    position: relative;

    @media ($above-mobile) {
        height: calc(100vh - var(--main-nav-height));
        max-height: 800px;
    }
}

.column1 {
    grid-column: 1 / span 3;
    display: flex;
    flex-direction: column;
    gap: var(--spacer-16);

    @media ($above-mobile) {
        height: 100%;
        overflow: hidden;
    }

    @media ($below-tablet) {
        grid-column: 1 / span 4;
    }

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }
}

.column1Inner {
    @media ($above-mobile) {
        --button-height: 3.5em;

        flex-grow: 1;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }
}

.column2 {
    grid-column: 4 / span 9;

    @media ($above-mobile) {
        height: 100%;
    }

    @media ($below-tablet) {
        grid-column: 5 / span 8;
    }

    @media ($below-mobile) {
        height: 50vh;
        grid-column: 1 / -1;
    }
}

.locationError {
    font: var(--font-p-16);
    margin-block: var(--spacer-16);
}

.title {
    margin-top: var(--spacer-32);
    font: var(--font-h-34);
}

.inputGroup {
    display: flex;
    gap: var(--spacer-8);
    align-items: center;
    margin-top: var(--spacer-16);

    .input {
        flex-grow: 1;

        > input {
            width: 100%;
        }
    }

    .submit {
        --height: 3.1em;

        > * {
            padding-inline: 1em;
        }

        .searchIcon {
            width: 1.33em;
            height: 1.33em;
        }
    }
}
